module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Tasks","newTask":"New task","modal":{"newTaskTitle":"New task","taskDetailsTitle":"Task details","cancel":"Cancel"}},"hr":{"title":"Zadaci","newTask":"Novi zadatak","modal":{"newTaskTitle":"Novi zadatak","taskDetailsTitle":"Detalji zadatka","cancel":"Odustani"}}}')
  delete Component.options._Ctor
}
